import { useCallback } from "react";
import type { FilterWidgetSettings } from "../../../../../api/types/dashboardsTypes";
import type { ConditionDescriptor } from "../../../../../api/types/fieldConfigurationTypes";
import type { DashboardFilter } from "../../dashboard.types";
import FilterValuesGrid from "./FilterValuesGrid";

interface Props {
  filter: DashboardFilter;
  settings: FilterWidgetSettings;
  parentCondition?: ConditionDescriptor;
  onSettingsChange: (settings: Partial<FilterWidgetSettings>) => void;
}

const TextList = ({ filter, settings, parentCondition, onSettingsChange }: Props) => {
  const handleSelectedValuesChange = useCallback(
    (defaultValue: (string | null)[]) => onSettingsChange({ defaultValue }),
    [onSettingsChange]
  );

  return (
    <FilterValuesGrid
      filter={filter}
      selectedValues={settings.defaultValue}
      singleSelect={settings.singleSelect}
      hideSecondaryColumn={settings.hideSecondaryColumn}
      parentCondition={parentCondition}
      onSelectedValuesChange={handleSelectedValuesChange}
    />
  );
};

export default TextList;
